import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const partners = [
  { name: 'AWS', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg' },
  { name: 'Google Cloud', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg' },
  { name: 'Azure', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a8/Microsoft_Azure_Logo.svg' }
];

const TrustedBy = () => {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(56,189,248,0.12),transparent_65%)]"></div>
      <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-3 items-center gap-10">
          <div className="flex md:justify-start justify-center">
            <div className="card-dark rounded-2xl p-5 w-32 h-24 flex items-center justify-center">
              <img src={partners[0].logo} alt="AWS" className="max-h-8 object-contain brightness-0 invert opacity-90" />
            </div>
          </div>

          <div className="text-center">
            <h2 className="font-display text-3xl md:text-5xl font-semibold text-white tracking-tight leading-tight">
              Trusted By <br /> Leading Companies
            </h2>
            <p className="text-slate-400 max-w-md mx-auto mt-6">
              Our services integrate with your infrastructure to enable secure, scalable automation and intelligent performance.
            </p>
            <a href="#contact" className="inline-flex mt-8">
              <button className="btn-gradient inline-flex items-center gap-2 rounded-full px-6 py-3 text-white text-sm font-medium">
                Let&apos;s work together
                <ArrowUpRight size={16} />
              </button>
            </a>
          </div>

          <div className="flex flex-col items-center md:items-end gap-6">
            <div className="card-dark rounded-2xl p-5 w-40 h-24 flex items-center justify-center">
              <img src={partners[1].logo} alt="Google Cloud" className="max-h-7 object-contain" />
            </div>
            <div className="card-dark rounded-2xl p-5 w-36 h-24 flex items-center justify-center">
              <img src={partners[2].logo} alt="Azure" className="max-h-7 object-contain" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
